import { getAPIUrlV2 } from "../apiConfig";
import { aiRoute } from "../routes";
import { authenticatedFetchJSON } from "@/services/authenticatedFetch";

export default class AIAPI {
    emitter = null;
    authService = null;
    socket = null;

    constructor(emitterInstance, authService = null) {
        this.emitter = emitterInstance;
        this.authService = authService;
    }

    async SuggestTemperatures(location_id) {
        try {
            this.Close();
            const ws = await this.createWebSocket("temperature-suggestions", location_id);
            this.socket = ws;
            this.setSocketListeners(ws);
        } catch (error) {
            console.error("Failed to establish WebSocket connection:", error);
            throw error;
        }
    }

    async GenerateCheckFormDraft(payload, idempotencyKey) {
        const response = await authenticatedFetchJSON(
            `${getAPIUrlV2(aiRoute)}/check-form-drafts`,
            {
                method: "POST",
                headers: { "Idempotency-Key": idempotencyKey },
                body: JSON.stringify(payload)
            },
            this.authService
        );
        if (!response.status) throw new Error(response.error || "AI draft request failed");
        return response.data;
    }

    // Fetch a short-lived, tenant-scoped ticket (authenticated call, so the
    // backend binds it to our own tenant) used to authenticate the WS upgrade.
    async getTicket() {
        try {
            const data = await authenticatedFetchJSON(
                `${getAPIUrlV2(aiRoute)}/authenticate`,
                {
                    method: "POST"
                },
                this.authService
            );

            if (!data.status) {
                throw new Error(`Authentication failed: ${data.error}`);
            }

            return data.data; // short-lived WebSocket auth ticket
        } catch (error) {
            console.error("Error retrieving auth ticket:", error);
            throw error;
        }
    }
    async SuggestByPrompt(prompt) {
        switch (prompt) {
            case "temperature":
                return await this.SuggestTemperatures();
            default:
                console.error("Invalid prompt:", prompt);
        }
    }
    setSocketListeners(ws) {
        ws.onopen = () => {
            // Connection opened
        };

        ws.onmessage = (event) => {
            this.emitter.emit("ai-suggest-data-received", event.data);
        };

        ws.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        ws.onclose = () => {
            if (this.socket === ws) {
                this.socket = null;
            }
        };
    }
    async createWebSocket(endpoint, locationId) {
        const ticket = await this.getTicket();

        // Convert HTTP/HTTPS URL to WebSocket URL
        const wsURL = getAPIUrlV2(aiRoute).replace(/^http/, "ws");

        return new WebSocket(`${wsURL}/${endpoint}?location_id=${locationId}&ticket=${ticket}`);
    }

    Close() {
        if (!this.socket) return;

        this.socket.onclose = null;
        this.socket.close();
        this.socket = null;
    }
}
